import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import styles from './Transaction.module.css';

function Transaction() {
    const navigate = useNavigate();
    const [birds, setBirds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchBirds();
    }, []);

    async function fetchBirds() {
        setLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem('token'));
            const response = await api.get('/transaction/mybirds', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBirds(response.data.birds || []);
        } catch (error) {
            console.error('Erro ao carregar transações/pássaros:', error);
        } finally {
            setLoading(false);
        }
    }

    const getGenderIcon = (gender) => {
        if (gender === 'male') return '♂';
        if (gender === 'female') return '♀';
        return '?';
    };

    const getGenderClass = (gender) => {
        if (gender === 'male') return styles.male;
        if (gender === 'female') return styles.female;
        return styles.undefined || '';
    };

    const filteredBirds = birds.filter(bird =>
        bird.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bird.bird_band_right?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bird.bird_band_left?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bird.race?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) {
        return <p className={styles.loading}>Carregando transações...</p>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.top_header}>
                <div>
                    <span className={styles.badge_category}>FINANCEIRO</span>
                    <h1>Transações de Aves</h1>
                    <p className={styles.subtitle}>Gerencie o histórico e registro de compra e venda do seu plantel.</p>
                </div>
                <div className={styles.count_box}>
                    <span className={styles.count_number}>{birds.length}</span>
                    <span className={styles.count_label}>aves</span>
                </div>
            </div>

            <div className={styles.search_row}>
                <div className={styles.search_input_wrapper}>
                    <span className={styles.search_icon}>🔍</span>
                    <input
                        type="text"
                        placeholder="Pesquisar ave por nome, anilha ou raça..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className={styles.birds_list}>
                {filteredBirds.length > 0 ? (
                    filteredBirds.map((bird) => (
                        <div key={bird._id} className={styles.bird_card}>
                            <div className={styles.bird_info_wrapper}>
                                <div className={`${styles.gender_icon} ${getGenderClass(bird.gender)}`}>
                                    {getGenderIcon(bird.gender)}
                                </div>
                                <div className={styles.bird_summary}>
                                    <h3>{bird.name}<br></br>({bird.bird_band_left} : {bird.bird_band_right}) </h3>
                                    <p> {bird.race} - {bird.color}</p>
                                    
                                    {/* Renderiza o container somente se houver alguma tag */}
                                    {(bird.is_purchased || bird.is_sold) && (
                                        <div className={styles.status_tags}>
                                            {bird.is_purchased && <span className={styles.badge_purchased}>Comprado</span>}
                                            {bird.is_sold && <span className={styles.badge_sold}>Vendido</span>}
                                        </div>
                                    )}
                                    
                                </div>
                                
                            </div>

                            <div className={styles.action_buttons}>
                                <button 
                                    className={styles.btn_buy}
                                    onClick={() => navigate(`/transaction/${bird._id}?type=purchase`)}
                                >
                                    Compra
                                </button>
                                <button 
                                    className={styles.btn_sell}
                                    onClick={() => navigate(`/transaction/${bird._id}?type=sale`)}
                                >
                                    Venda
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className={styles.empty_list}>
                        <p>Nenhuma ave encontrada.</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Transaction;